import { BASE_URL } from '../constants'
import { token } from '../../localStorage/index'

export const getTalentContract = async () => {
  const URL = `${BASE_URL}contract/oneTalent`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const signTalentContract = async ({
  signature,
  accept,
  fullName,
  address,
  dni,
  contracId,
}) => {
  const URL = `${BASE_URL}contract/signingTalent`
  const rawBody = JSON.stringify({
    signature,
    accept,
    fullName,
    address,
    dni,
    contracId,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}
